'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgGift(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M9.714 2.25a2.143 2.143 0 012.1 2.572h1.757c.237 0 .429.191.429.428v.857a.429.429 0 01-.429.429h-.482c.035.137.054.28.054.428v5.143c0 .947-.768 1.714-1.714 1.714H4.57a1.714 1.714 0 01-1.714-1.714V6.964c0-.148.019-.291.054-.428H2.43A.429.429 0 012 6.107V5.25c0-.237.192-.429.429-.429h1.757A2.143 2.143 0 018 3.108a2.134 2.134 0 011.713-.857zm2.143 4.286h-3v4.714H7.143V6.536h-3v5.571c0 .237.192.429.428.429h6.858a.429.429 0 00.428-.429V6.536zm-5.571-3a.857.857 0 100 1.714.857.857 0 000-1.714zm3.428 0a.857.857 0 100 1.714.857.857 0 000-1.714z", fill: "currentColor" }))));
}

module.exports = SvgGift;
//# sourceMappingURL=Gift.js.map
